/* eslint-disable import/no-anonymous-default-export */
export default {
  mode: 'light',
  primary: {
    100: '#FCE9EC',
    200: '#F8C7CF',
    300: '#F07D90',
    400: '#EC6178',
    500: '#D23F57',
    600: '#E63E58',
    700: '#E3364E',
    800: '#DF2E44',
    900: '#D91F33',
    light: '#FCE9EC',
    main: '#D23F57',
    dark: '#E3364E',
    contrastText: '#fff',
  },
  dark: {
    main: '#222',
  },
  grey: {
    50: '#fafafa',
    100: '#F6F9FC',
    200: '#F3F5F9',
    300: '#E3E9EF',
    400: '#DAE1E7',
    500: '#AEB4BE',
    600: '#7D879C',
    700: '#4B566B',
    800: '#373F50',
    900: '#2B3445',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  paste: {
    50: '#F5F5F5',
    100: '#DDFBF1',
    200: '#BDF7E8',
    300: '#97E8DA',
    400: '#76D2CA',
    600: '#36929A',
    700: '#257181',
    800: '#175368',
    900: '#0E3D56',
    main: '#4BB4B4',
    contrastText: '#FFFFFF',
  },
  error: {
    100: '#FFEAEA',
    200: '#FFCBCB',
    300: '#FFA9A9',
    400: '#FF6D6D',
    500: '#FF5353',
    600: '#FF4C4C',
    700: '#FF4242',
    800: '#FF3939',
    900: '#FF2929',
    main: '#E94560',
    light: '#FFA9A9',
    dark: '#FF4242',
    contrastText: '#fff',
  },
  marron: {
    50: '#f3f5f9',
    100: '#F6F2ED',
    200: '#F8DBD1',
    300: '#EBBCB3',
    400: '#D89C98',
    600: '#A3545C',
    700: '#883948',
    800: '#6E2438',
    900: '#5B162F',
    main: '#BE7374',
  },
  warning: {
    100: '#FFF8E5',
    main: '#FFCD4E',
    contrastText: '#FFFFFF',
    light: 'rgb(255, 215, 113)',
    dark: 'rgb(178, 143, 54)',
  },
  success: {
    100: '#E7F9ED',
    200: '#C2F1D1',
    300: '#99E8B3',
    400: '#52D77E',
    500: '#33D067',
    600: '#2ECB5F',
    700: '#27C454',
    800: '#20BE4A',
    900: '#0b7724',
    main: 'rgb(51, 208, 103)',
    light: '#99E8B3',
    dark: '#27C454',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  secondary: {
    100: '#e8e8ee',
    200: '#b9bacb',
    300: '#8a8ca8',
    400: '#5b5d85',
    500: '#141850',
    600: '#0F3460',
    700: '#101340',
    800: '#0e1138',
    900: '#0c0e30',
    main: '#0F3460',
    dark: '#0c0e30',
    light: 'rgb(63, 92, 127)',
    contrastText: '#fff',
  },
  info: {
    50: '#f3f5f9',
    100: '#DBF0FE',
    200: '#B8DEFE',
    300: '#94C9FE',
    400: '#7AB6FD',
    500: '#4E97FD',
    600: '#3975D9',
    700: '#2756B6',
    800: '#183C92',
    900: '#0E2979',
    main: '#4E97FD',
    contrastText: '#FFFFFF',
    light: '#94C9FE',
    dark: '#2756B6',
  },
  divider: '#F3F5F9',
  background: {
    default: '#F6F9FC',
    paper: '#fff',
  },
  text: {
    primary: '#2B3445',
    secondary: '#373F50',
    disabled: '#DAE1E7',
  },
  common: {
    black: '#000',
    white: '#fff',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  }
}
